import styled from 'styled-components';

export const ResponseWrapper = styled.div`
    margin-bottom: 4px;
`;
